import AppService from "./app-service"
import errorHandler from "./error-handler"

const path = "bookmarks"

export default class BookmarkService extends AppService {

  constructor() {
    
    super({ path })

    this.errorHandler = errorHandler
  } 

  async loadCurrentUserBookmarks() {
    
    try {

      const bookmarks = await this.http.get(`user-bookmarks?userId=${this.store.state.auth.user.id}`)

      this.store.commit("auth/setBookmarks", bookmarks)
      
    } catch (error) {      
      this.errorHandler(error)
    }
  }
}